/**
 * It's a generated file, preferable to extend this in external file
 */
import {enumType} from 'common/enumType';

export const DiplomatObjectAceType = enumType({
   VIEW: 'View',
   MODIFY: 'Modify',
   PERMISSIONS: 'Permissions',
   ADD_OBJECT: 'Add Object',
   REMOVE_OBJECT: 'Remove Object',
   SUSPEND_RELEASE: 'Suspend Release',
   EXECUTE: 'Execute',
});
export type IDiplomatObjectAceType = keyof typeof DiplomatObjectAceType;
